import ICPCommonSearchResult from "./Common/ICPCommonSearchResult";
import "../SearchResults.css";
const ICPSearchResultHandler = ({ apiResponseData }) => {
  /** Add validation if results will become specific with the results */
  return <ICPCommonSearchResult apiResponseData={apiResponseData}></ICPCommonSearchResult>;
};

export default ICPSearchResultHandler;
